// Story 12.4 — Initiates connect on /api/v1/bots/:id/whatsapp/connect.
// Returns either `already-connected` (no QR needed) or `qr-pending` (the
// modal then fetches the QR).

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { api } from '@/lib/api-client';

export interface EvolutionConnectResponse {
  status: 'qr-pending' | 'already-connected';
  jid?: string;
}

export function useEvolutionConnect(botId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api.post<EvolutionConnectResponse>(`/api/v1/bots/${botId}/whatsapp/connect`, {}),
    onSuccess: (res) => {
      void qc.invalidateQueries({ queryKey: ['bots', botId, 'evolution-status'] });
      if (res.status === 'already-connected') {
        toast.success('WhatsApp ya está conectado.');
      }
    },
    onError: (err) => {
      toast.error(`No se pudo iniciar la conexión: ${(err as Error).message}`);
    },
  });
}

export function useEvolutionDisconnect(botId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post(`/api/v1/bots/${botId}/whatsapp/logout`, {}),
    onSuccess: () => {
      toast.success('Sesión de WhatsApp cerrada.');
      void qc.invalidateQueries({ queryKey: ['bots', botId, 'evolution-status'] });
    },
    onError: (err) => {
      toast.error(`No se pudo cerrar sesión: ${(err as Error).message}`);
    },
  });
}
